import { mapGetters } from 'vuex'

export const pricingMixin = {
  data () {
    return {
      currency_symbols: {
        CAD: '$', // Canadian Dollar
        USD: '$', // US Dollar
        EUR: '€', // Euro
        CRC: '₡', // Costa Rican Colón
        GBP: '£', // British Pound Sterling
        ILS: '₪', // Israeli New Sheqel
        INR: '₹', // Indian Rupee
        JPY: '¥', // Japanese Yen
        KRW: '₩', // South Korean Won
        NGN: '₦', // Nigerian Naira
        PHP: '₱', // Philippine Peso
        PLN: 'zł', // Polish Zloty
        PYG: '₲', // Paraguayan Guarani
        THB: '฿', // Thai Baht
        UAH: '₴', // Ukrainian Hryvnia
        VND: '₫' // Vietnamese Dong
      }
    }
  },
  mounted () {},
  computed: {
    ...mapGetters(['activeChallenge']),
    activeChallengePrice () {
      let challengePrice
      let currencySymbol
      let upperCaseCurrency
      if (this.activeChallenge) {
        upperCaseCurrency = this.activeChallenge.plans[0].currency.toUpperCase()
        challengePrice = (this.activeChallenge.plans[0].unit_amount / 100).toFixed(2)
        currencySymbol = this.currency_symbols[upperCaseCurrency]
        return `${currencySymbol}${challengePrice} ${upperCaseCurrency}`
      } else {
        return null
      }
    }
  },
  methods: {
    $_currencySymbol (plan) {
      const currency = plan.currency.toUpperCase()
      return this.currency_symbols[currency]
    },
    $_priceFormat (price) {
      let challengePrice
      let currencySymbol
      let upperCaseCurrency
      if (price) {
        upperCaseCurrency = price.currency.toUpperCase()
        challengePrice = (price.unit_amount / 100).toFixed(2)
        currencySymbol = this.currency_symbols[upperCaseCurrency]
        return `${currencySymbol}${challengePrice} ${upperCaseCurrency}`
      } else {
        return null
      }
    },
    $_getPlanNickName (subscription) {
      const interval = subscription.interval
      const intervalCount = subscription.interval_count
      if (interval === 'year') { return 'annually' }
      if (interval === 'month') { if (intervalCount === 1) { return 'monthly' } if (intervalCount === 3) { return 'quarterly' } }
      if (interval === 'week') { return 'weekly' }
      if (interval === 'day') { return 'daily' }
    }
  }
}
